import { HttpRepository } from '@/modules/shared/shared/domain/repositories/http.repository';

class BillsRepository extends HttpRepository {
    private static readonly RESOURCE = 'bills';
    getBill(file: string) {
        return this.get(
            this.createUri(['customers', 'invoices'], { fileName: file }),
            this.createAuthorizationDocumentsHeader(),
        );
    }
}
const billsRepository = new BillsRepository();
export default billsRepository;
